import { HttpClient } from '../common/httpClient';
import { MetaAccount, MetaChannel, PhoneNumber } from '../../types/meta/metaAccount';
import dateTimeService from '../../service/dateTimeService';

type WhatsappPhoneNumberResponse = {
  readonly name?: string;
  readonly phoneNumber?: string;
  readonly phoneNumberId: string;
  readonly isActive?: boolean;
  readonly isFetched?: boolean;
  readonly businessAccountId: string;
  readonly externalId: string;
};

export class WhatsappPhoneNumberApi {
  constructor(private readonly httpClient: HttpClient) { }

  private mapToWhatsappPhoneNumber(response: WhatsappPhoneNumberResponse): PhoneNumber {
    return {
      businessAccountId: response.businessAccountId,
      externalId: response.externalId,
      phoneNumberId: response.phoneNumberId,
      name: response.name,
      phoneNumber: response.phoneNumber,
    };
  }

  private mapToMetaAccount(response: any): MetaAccount {
    return {
      appId: response.appId,
      channel: response.channel as MetaChannel,
      name: response.name,
      businessAccountId: response.businessAccountId,
      isDisabled: response.isDisabled,
      metaAppId: response.metaAppId,
      tenantId: response.tenantId,
      createdAt: dateTimeService.convertIsoDateToTimestamp(response.createdAt),
      updatedAt: dateTimeService.convertIsoDateToTimestamp(response.updatedAt),
      phoneNumbers: (response.phoneNumbers || []).map((it: WhatsappPhoneNumberResponse) =>
        this.mapToWhatsappPhoneNumber(it)
      ),
      status: response.status,
    };
  }

  getPhoneNumbersById(businessAccountId: string): Promise<PhoneNumber[]> {
    return this.httpClient.get<WhatsappPhoneNumberResponse[]>(`accounts/${businessAccountId}/phone_numbers`)
      .then(data => (
        data.map(it => this.mapToWhatsappPhoneNumber(it))
      ));
  }

  syncPhones(): Promise<MetaAccount> {
    return this.httpClient.get<any>('phones/sync').then((data) => this.mapToMetaAccount(data));
  }
}
